export const redirectToPage = (url) => {
    if (!url) {
        return;
    }

    const encodedUrl = encodeURI(url);

    if (encodedUrl.startsWith('/')) {
        window.history.pushState({}, '', encodedUrl);
        window.dispatchEvent(new PopStateEvent('popstate'));
    } else {
        window.location.href = encodedUrl;
    }
};

export const addQueryParam = (key, value) => {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    if (params.has(key)) {
        params.set(key, value);
    } else {
        params.append(key, value);
    }

    window.history.pushState({}, '', url);
};
